export default {
  NONE: 0,
  NORMAL: 1,
  STAR: 2,
  WORD_2X: 4,
  WORD_3X: 8,
  CHAR_2X: 16,
  CHAR_3X: 32,
};
